import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { FestivalButtonHandlersProvider } from '../festival/ButtonHandlersProvider/FestivalButtonHandlersProvider'
import { FestivalPlayerPage } from '../festival/FestivalPlayerPage/FestivalPlayerPage'
import GroupWatchPlayerPage from '../groupWatch/GroupWatchPlayerPage/GroupWatchPlayerPage'
import FeaturePlayerPage from './players/FeaturePlayerPage'
import TrailerPlayerPage from './players/TrailerPlayerPage'
import VideoPlayerPage from './players/VideoPlayerPage'

const PlayerRoutes = () => {
  const { url, params } = useRouteMatch()
  if (process.env.SERVER) {
    return null
  }
  return (
    <Switch>
      <Route
        path={`${url}/feature`}
        render={(props) => <FeaturePlayerPage {...props} {...params} />}
      />
      <Route path={`${url}/trailer`} render={() => <TrailerPlayerPage {...params} />} />

      <Route path="/group-watch/player" component={GroupWatchPlayerPage} />

      <Route
        path={`/festival/player/:festivalId/:filmSlug`}
        render={(props) => (
          <FestivalButtonHandlersProvider>
            <FestivalPlayerPage {...props} {...params} />
          </FestivalButtonHandlersProvider>
        )}
      />

      <Route path={`${url}`} render={(props) => <VideoPlayerPage {...props} />} />
    </Switch>
  )
}

export default PlayerRoutes
